/**
 * useConfetti
 * 버튼 클릭 위치에서 폭죽(파티클) 애니메이션을 발사하는 훅
 * 외부 라이브러리 없이 순수 DOM + CSS 애니메이션으로 구현
 */

const COLORS = [
    '#19cf7a', '#00b368', '#a8f0cc',  // 그린 계열
    '#fbbf24', '#f59e0b',              // 골드
    '#60a5fa', '#3b82f6',              // 블루
    '#f472b6', '#ec4899',              // 핑크
    '#a78bfa',                         // 퍼플
    '#fb923c',                         // 오렌지
];

interface ConfettiOptions {
    count?: number;       // 파티클 개수 (기본 28)
    spread?: number;      // 퍼짐 반경px (기본 120)
    duration?: number;    // 애니메이션 ms (기본 700)
    originY?: number;     // 발사 y 보정값 (기본 0 = 클릭 위치)
}

const injectKeyframes = () => {
    if (document.getElementById('confetti-keyframes')) return;
    const style = document.createElement('style');
    style.id = 'confetti-keyframes';
    style.textContent = `
        @keyframes confetti-fly {
            0%   { transform: translate(0, 0) rotate(0deg) scale(1);   opacity: 1; }
            70%  { opacity: 1; }
            100% { transform: translate(var(--tx), var(--ty)) rotate(var(--rot)) scale(0.4); opacity: 0; }
        }
        @keyframes confetti-pop {
            0%   { transform: scale(0); opacity: 0; }
            30%  { transform: scale(1.4); opacity: 1; }
            60%  { transform: scale(0.9); opacity: 1; }
            100% { transform: scale(0); opacity: 0; }
        }
    `;
    document.head.appendChild(style);
};

export const triggerConfetti = (
    e: React.MouseEvent | { clientX: number; clientY: number },
    options: ConfettiOptions = {}
) => {
    injectKeyframes();

    const {
        count = 28,
        spread = 130,
        duration = 750,
        originY = 0,
    } = options;

    const originX = e.clientX;
    const originYPos = e.clientY + originY;

    for (let i = 0; i < count; i++) {
        const color = COLORS[Math.floor(Math.random() * COLORS.length)];

        // 파티클 모양: 원, 직사각형, 별 중 랜덤
        const shape = Math.random();
        const size = 6 + Math.random() * 7; // 6~13px

        const el = document.createElement('div');
        el.style.cssText = `
            position: fixed;
            pointer-events: none;
            z-index: 99999;
            left: ${originX}px;
            top: ${originYPos}px;
            width: ${shape < 0.5 ? size : size * 1.6}px;
            height: ${shape < 0.5 ? size : size * 0.6}px;
            background: ${color};
            border-radius: ${shape < 0.33 ? '50%' : shape < 0.66 ? '2px' : '50% 0 50% 0'};
            opacity: 1;
        `;

        // 랜덤 방향 벡터 (위쪽 반원 중심으로 퍼짐)
        const angle = (Math.random() * Math.PI * 2);        // 전방향
        const distance = spread * (0.4 + Math.random() * 0.7);
        const tx = Math.cos(angle) * distance;
        const ty = Math.sin(angle) * distance - spread * 0.3; // 위쪽으로 약간 치우침
        const rot = (Math.random() - 0.5) * 720;

        el.style.setProperty('--tx', `${tx}px`);
        el.style.setProperty('--ty', `${ty}px`);
        el.style.setProperty('--rot', `${rot}deg`);

        const delay = Math.random() * 80; // 0~80ms 딜레이로 자연스럽게

        el.style.animation = `confetti-fly ${duration}ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${delay}ms both`;

        document.body.appendChild(el);
        setTimeout(() => el.remove(), duration + delay + 50);
    }

    // 중앙 빛남 효과 (큰 원)
    const glow = document.createElement('div');
    glow.style.cssText = `
        position: fixed;
        pointer-events: none;
        z-index: 99998;
        left: ${originX - 20}px;
        top: ${originYPos - 20}px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(25,207,122,0.6) 0%, rgba(25,207,122,0) 70%);
        animation: confetti-pop 400ms ease-out both;
    `;
    document.body.appendChild(glow);
    setTimeout(() => glow.remove(), 450);
};
